'use client';

import { ReactNode, RefObject, useEffect, useState } from 'react';
import { useElementOnScreen } from 'app/utils/common';

/**
 * Monta a sus hijos solo cuando el contenedor se acerca al viewport (y ya no
 * los desmonta). Sirve para diferir cosas caras que van al final de la
 * página, como el mapa de Google (~240 KB de JS) del bloque de clínicas.
 */
export default function RenderOnView({
  children,
  className = '',
  rootMargin = '400px',
  placeholder = null,
}: {
  children: ReactNode;
  className?: string;
  rootMargin?: string;
  placeholder?: ReactNode;
}) {
  const [ref, isInViewport] = useElementOnScreen({
    root: null,
    rootMargin,
    threshold: 0,
  });
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    if (isInViewport) setShouldRender(true);
  }, [isInViewport]);

  return (
    <div ref={ref as RefObject<HTMLDivElement>} className={className}>
      {shouldRender ? children : placeholder}
    </div>
  );
}
